import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { CustomInput } from "reactstrap";
import classNames from "classnames";

const getColWidth = (column, autoColumnWidth) => !column.width || column.width === "auto" ? autoColumnWidth : column.width;

const concatMakeAndModel = (make, model) => `${make || ""}${model ? ` ${model}` : ""}`;

class DeviceTableRow extends PureComponent {
  select = e => {
    const id = parseInt(e.target.id.replace("device#", ""), 10);

    this.props.selectElement(id, false);
  };

  render() {
    const { className, device, hasReassignPermission, canAccessDeveloperSettings, selected, showCheckboxes, canAccessSimCards, columns, autoColumnWidth } = this.props;

    const makeAndModel = concatMakeAndModel(device.make, device.model);

    const columnsWidths = columns.map(x => getColWidth(x, autoColumnWidth));
    
    return (
      <div className={classNames("div-table-row", className)}>
        {showCheckboxes && (
          <div className="div-table-cell" style={{ width: columnsWidths[0], maxWidth: columnsWidths[0] }}>
             <CustomInput type="checkbox" id={`device#${device.id}`} checked={selected} onChange={this.select} disabled={!hasReassignPermission} />
          </div>
         )}
        <div className="div-table-cell" style={{ width: columnsWidths[1], maxWidth: columnsWidths[1] }} title={device.description}>{device.description}</div>
        <div className="div-table-cell" style={{ width: columnsWidths[2], maxWidth: columnsWidths[2] }} title={makeAndModel}>{makeAndModel}</div>
        <div className="div-table-cell" style={{ width: columnsWidths[3], maxWidth: columnsWidths[3] }} title={device.vrn}>{device.vrn}</div>
        <div className="div-table-cell" style={{ width: columnsWidths[4], maxWidth: columnsWidths[4] }} title={device.vehicleNumber}>{device.vehicleNumber}</div>
        <div className="div-table-cell" style={{ width: columnsWidths[5], maxWidth: columnsWidths[5] }} title={device.serialNumber}>{device.serialNumber}</div>
        <div className="div-table-cell" style={{ width: columnsWidths[6], maxWidth: columnsWidths[6] }}>{device.imei}</div>
        <div className="div-table-cell" style={{ width: columnsWidths[7], maxWidth: columnsWidths[7] }}>
          <span>{device.ccid}</span>
          {canAccessSimCards && !!device.simCardId && (
            <span className="ml-1">
              <Link to={`/simCards/details/${device.simCardId}`} title="Przejdź do szczegółów karty SIM">
                <FontAwesomeIcon icon="link" size="xs" color="#17a2b8" />
              </Link>
            </span>
          )}
        </div>
        <div className="div-table-cell" style={{ width: getColWidth(columns[8], autoColumnWidth) }}>
           <span>{device.simCardPhoneNumber}</span>
        </div>
        {canAccessDeveloperSettings && <div className="div-table-cell" style={{ width: getColWidth(columns[9], autoColumnWidth) }}>{device.id}</div>}
      </div>
    );
  }
}

export default DeviceTableRow;
